import React, {memo} from 'react'
import {TModuleListRow} from '../_types'
import {useFormikContext} from 'formik'
import ComponentCheckbox from '../../../components/ComponentCheckbox'
import {ListCell} from './ListCell'

export const ListRow: React.FC<TModuleListRow> = memo(props => {
  const { data, headers, page, filterKeys, isListEditable, setFilter, setIndividualPage, isNewUI } = props
  const { values, setFieldValue } = useFormikContext<{ selectedItems: Array<any> }>()

  const { selectedItems } = values

  /*
  --- Для строк без id отключаем чекбокс выбора строки
  */
  const isCheckboxEnabled = Boolean(data.id)

  const indexOfRow = isCheckboxEnabled ? selectedItems.findIndex(selectedItem => selectedItem.id === data.id) : -1

  const isRowChecked = indexOfRow !== -1


  const handleDeleteCheckboxClick = () => {
    if (!isCheckboxEnabled) {
      return
    }

    const itemsToDeleteClone = [...selectedItems]
    if (isRowChecked) {
      itemsToDeleteClone.splice(indexOfRow, 1)
    } else {
      itemsToDeleteClone.push(data)
    }
    return setFieldValue("selectedItems", itemsToDeleteClone)
  }

  return <tr className={`moduleList_row ${isRowChecked ? " selected" : ""}`}>
    {
      isListEditable ? <td className="moduleList_cell deleteCheckbox">
        <ComponentCheckbox customChecked={isRowChecked} customHandler={handleDeleteCheckboxClick} is_disabled={!isCheckboxEnabled} />
      </td> : null
    }
    {headers.map(cell => <ListCell
        key={cell.article}
        article={cell.article}
        type={cell.type}
        row={data}
        page={page}
        filterable={filterKeys.includes(cell.article)}
        setFilter={setFilter}
        setIndividualPage={setIndividualPage}
        suffix={cell.suffix}
        isNewUI={isNewUI}
        is_hex={cell.is_hex}
      />
    )}
  </tr>
})